import React, { Component } from 'react'; 
import { withstyles, Paper, Typography, Button, Radio, RadioGroup, FormControl, FormControlLabel, FormLabel, withStyles, TextField, Divider, MenuItem,
    Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Slide, FormGroup, Checkbox, Grid } from '@material-ui/core';
import { } from '@material-ui/icons';
import Select from 'react-select';
import fb from '../../config/firebaseConfig';
import db from '../../config/firestoreConfig';
import abilities from '../View/abilities';

function Transition(props) {
    return <Slide direction="up" {...props} />;
}

const styles = theme => ({
    root: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
        margin: 'auto',
        width: '75%',
        overflowX: 'auto'
      },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    paper: {
        padding: theme.spacing.unit * 2,
        textAlign: 'center',
        color: theme.palette.text.secondary,
        height: 'auto',
        overflowX: 'auto'
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: 300,
        padding: 5,
    },
    button: {
        margin: theme.spacing.unit,
    },
})


class Groups extends Component{
    constructor(props){
        super(props)
        this.state = {
            levels : [],
            subjects: [],
            years: [],
            dbObjects: [] ,
            abilities: ['Beginner', 'Intermediate', 'Advanced'],
            groupLevel: '',
            students: [],
            selected: [],
            groupSubject: '',
            groupYear: '',
            groupAbility: '',
            rename: false
        }
    }

    componentDidMount(){
        var objectArr = []
        const levelRef = db.collection('Level')
        levelRef.get()
            .then(snapshot => {
                snapshot.forEach( level => {
                    var subj = []
                    // console.log(level.id)
                    this.state.levels.push(level.id)
                    // console.log(this.state.levels)
                    const subjRef = levelRef.doc(level.id).collection('Subjects')
                    subjRef.get()
                    .then(snapshot => {
                        snapshot.forEach(subject => {
                            // console.log('sibject id', subject.id)
                            var years = []
                            subj.push(subject.id)
                            const yearRef = subjRef.doc(subject.id).collection('Years')
                            yearRef.get()
                            .then(snapshot => { 
                                snapshot.forEach(year => { 
                                    var abilities = []
                                    years.push(year.id)
                                    const abilityRef = yearRef.doc(year.id).collection('Abilities')
                                    abilityRef.get()
                                    .then(snapshot=> { 
                                        snapshot.forEach(ability => { 
                                            if (ability.id == 'Intermediate') {
                                                var dbObject = {level: level.id, subject: subject.id, year: year.id, ability: ability.id, }
                                                objectArr.push({level: level.id, subject: subject.id, year: year.id, ability: ability.id, })
                                                console.log(objectArr.length)
                                                this.state.dbObjects.push(dbObject)
                                                var content = []
                                                abilities.push([level.id, subject.id, year.id, ability.id])
                                                var obj = [level.id, subject.id, year.id, ability.id, ]
                                            }
                                        })
                                    })
                                })
                            })   
                        }) 
                    }) 
                    this.state.subjects.push(subj)
                })
            })
            console.log(this.state)
            db.collection('Users').where('accountType', '==', 'Student').get()
            .then(snapshot => {
                var arr = [] 
                snapshot.forEach(doc => { 
                    arr.push(
                        {
                            label: doc.data().displayName,
                            value: doc.data().UID,
                            name: doc.data().displayName,
                        }
                    )
                })
                this.setState({
                    ...this.state,
                    students: arr
                })
            })
        }


    handleChange = name => event => {
       
        const state = {
            ...this.state,
            [name]: event.target.value,
            nameError: false,

        };
        this.setState(state)
        // console.log(this.state) //debug line
    };

    handleClick = (name) => { 
        this.setState({
            ...this.state,
            open: true,
            currentHwk: name
        })

    }
    handleClose = () => {
        this.setState({
            open: false,
            rename: false,
        })
    }

    handleCheck = (opt, meta)  => {
        var arr = []
        opt.forEach(student => { 
            arr.push(student)
        })
        console.log(arr)
        this.setState({selected: arr})
    }

    
    setTask = async () => {
        const level = this.state.groupLevel;
        const subject = this.state.groupSubject;
        const year = this.state.groupYear;
        const ability = this.state.groupAbility
        const students = this.state.selected;
        console.log(level, subject, year, ability, students)

        var newArr = []
        students.forEach(student => {
            this.state.students.forEach(obj => {
                if (obj.value == student.value) {
                    return newArr.push(obj)
                }
            })
        })

        // console.log(students, newArr, this.state.students, 'MEMBERS')
        const finalObj = {
            Members: newArr,
            name: this.state.groupName,
            level: level,
            year: year,
            subject: subject
        };
        
        console.log(subject)
        console.log(level)
        
        var ref = await db.collection('WorkGroups').where('name', '==', finalObj.name).get()
        console.log('232', ref, ref.empty, ref.size, ref.docs, !ref.empty)
        if (!ref.empty){
            return this.setState({...this.state, nameError: true, rename: true})
        } else {
            db.collection('WorkGroups').doc().set(finalObj, {merge: true})
            .then(() => {
                const ref = db.collection('Level').doc(level).collection('Subjects').doc(subject).collection('Years').doc(year).collection('Abilities').doc(ability)
                ref.get()
                    .then(doc => {
                        var classes
                        console.log(doc.data())
                        if (doc.data().data.Classes) { 
                            classes = doc.data().data.Classes.concat(this.state.groupName);
                        } else { 
                            classes = this.state.groupName
                        }
                        console.log(classes)
                        ref.set({data: {Classes: classes}}, {merge: true});
                        window.alert('Group ' + this.state.groupName + ' saved ')
                        // console.log('MEMBERS', finalObj)
                        this.reset()
                     }); 
            })
            .catch((error) => {
                window.alert('There was an error ' + error)
            })
        }
    }

    checkNameChanged = name => { 
        this.setTask()
    }

    groupExists = async obj => { 
        var ref = await db.collection('WorkGroups').where('name', '==', obj.name).get()
        console.log('232', ref, ref.empty, ref.size, ref.docs, !ref.empty)
        return !ref.empty
    }

    reset = () => { 
        window.location.reload()
    }

    getSubjects = (arr, level) => { 
        var subjects = []
        var output =  [] 
        arr.forEach(obj => { 
            if (!subjects.includes(obj.subject) && obj.level == level) { 
                console.log(subjects, obj.subject)
                subjects.push(obj.subject)
                output.push(obj)
            }
        })
        return subjects
    }

    render(){
        const { classes } = this.props;
        return (
            (this.state.subjects.length > 0 ? (
                <div>
                    <Paper className={classes.root} elevation={1}>
                        <Typography variant="headline">
                            Create Groups 
                        </Typography>
                        <Divider/>
                        <br/>
                        <Grid container
                            spacing={24}
                            direction='row'
                            justify='space-evenly'
                            alignContent='center'
                            style={{overflowX: 'auto'}}
                        >
                            <Grid item lg={12}>
                                <Paper className={classes.paper}>
                                <Typography variant="headline">
                                    New Group details 
                                </Typography>
                                <Divider/>
                                    <Grid container
                                        spacing={24}
                                        direction='row'
                                        justify='space-evenly'
                                        alignContent='center'
                                        style={{overflowX: 'auto'}}
                                    >
                                        <Grid item lg={12} xl={3}>
                                            <form >
                                                <div style={{ paddingTop: 50, width: '100%', margin: 'auto'}}>
                                                <TextField
                                                id='name'
                                                // label='Name'
                                                className={classes.textField}
                                                value={this.state.groupName}
                                                onChange={this.handleChange('groupName')}
                                                margin='normal'
                                                placeholder='Please enter the group name'
                                                error={this.state.nameError}
                                            />
                                            <br/>
                                            <TextField
                                                id='Level'
                                                select
                                                className={classes.textField}
                                                value={this.state.groupLevel}
                                                onChange={this.handleChange('groupLevel')}
                                                margin='normal'
                                                helperText='Please select the Academic Level'
                                            >
                                            {this.state.levels.map(level => (
                                                <MenuItem key={this.state.levels.indexOf(level) + 1} value={level}> 
                                                    {level}
                                                </MenuItem>
                                            ))}
                                            </TextField>
                                            <br/>
                                            <TextField
                                                id='Subject'
                                                select
                                                className={classes.textField}
                                                value={this.state.groupSubject}
                                                onChange={this.handleChange('groupSubject')}
                                                margin='normal'
                                                helperText='Please select the groups Subject'
                                            >
                                            {(this.state.levels.indexOf(this.state.groupLevel) != -1) ? (
                                                            this.getSubjects(this.state.dbObjects, this.state.groupLevel).map(obj =>  {
                                                                return (
                                                                    <MenuItem key={1} value={obj}> 
                                                                        {obj}
                                                                    </MenuItem>
                                                                )
                                                            })
                                                        ) : (
                                                            <div/>
                                                        )
                                                        }
                                            </TextField>
                                            <br/>
                                            <TextField
                                                id='Year'
                                                select
                                                className={classes.textField}
                                                value={this.state.groupYear}
                                                onChange={this.handleChange('groupYear')}
                                                margin='normal'
                                                helperText='Please select the groups year'
                                            >
                                            {(this.state.levels.indexOf(this.state.groupLevel) != -1) ? (
                                                            this.state.dbObjects.map(obj =>  {
                                                                if (obj.level == this.state.groupLevel && obj.subject == this.state.groupSubject) { 
                                                                    return (
                                                                        <MenuItem key={this.state.dbObjects.indexOf(obj)} value={obj.year}> 
                                                                            {obj.year}
                                                                        </MenuItem>
                                                                    )
                                                                }
                                                            })
                                                        ) : (
                                                            <div/>
                                                        )
                                                        }
                                            </TextField>
                                            <br/>
                                            <TextField
                                                id='Ability'
                                                select
                                                className={classes.textField}
                                                value={this.state.groupAbility}
                                                onChange={this.handleChange('groupAbility')}
                                                margin='normal'
                                                helperText='Please select the groups Ability level'
                                            >
                                            {(this.state.levels.indexOf(this.state.groupLevel) != -1) ? (
                                                            this.state.abilities.map(ability =>  {
                                                                return (
                                                                    <MenuItem key={this.state.abilities.indexOf(ability)} value={ability}> 
                                                                        {ability}
                                                                    </MenuItem>
                                                                )  
                                                            }) 
                                                        ) : (
                                                            <div/>
                                                        )
                                                        }
                                            </TextField>
                                            <br/>
                                            <Button className={classes.button} variant='outlined' onClick={() => this.handleClick()}>
                                                Create group
                                            </Button>
                                                </div>
                                            </form>
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>
                        </Grid>
                    </Paper>
                    <Dialog
                        open={this.state.open}
                        TransitionComponent={Transition}
                        keepMounted
                        onClose={this.handleClose}
                        aria-labelledby='form-dialog-title'
                        
                    >
                    <DialogTitle id='form=dialog-title'> Assign Students</DialogTitle>
                    <DialogContent>
                        
                        <FormControl compoent='fieldset' className={classes.textField}>
                                {this.state.students.length > 0 ? (
                                <div>
                                    <FormLabel component='legend'>Which students to assign to group</FormLabel>
                                    <Divider/>
                                    <br/>
                                    <Select 
                                        options={this.state.students} 
                                        maxMenuHeight={300}
                                        isMulti
                                        onChange={(opt, meta) => this.handleCheck(opt, meta)}
                                    />
                                </div>
                                ) : 
                                (
                                    <div>
                                        <FormLabel component='legend'>You have no students in this class to assign to</FormLabel>
                                        <br/>
                                        <Button variant='contained' className={classes.button}>
                                            Create Students?
                                        </Button>
                                    </div>
                                )}
                        </FormControl>
                        <br/>
                        <Divider/>
                        <br/>
                        <Button variant='contained' className={classes.button} onClick={() => this.setTask()}>
                            Save Group
                        </Button>
                        
                    </DialogContent>
                    </Dialog>
                    <Dialog
                        open={this.state.rename}
                        TransitionComponent={Transition}
                        keepMounted
                        onClose={this.handleClose}
                        aria-labelledby='form-dialog-title'
                    >
                    <DialogTitle id='form-dialog-title'>Please rename group</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            A group already exists with this name. Please rename and save.
                        </DialogContentText>
                            <br/>
                            <TextField
                            autoFocus
                            margin="dense"
                            id="name"
                            label="Group Name"
                            type="text"
                            helperText='Only numbers and letters.'
                            value={this.state.title}
                            onChange={this.handleChange('groupName')}
                            error={this.state.nameError}
                            fullWidth
                            />
                            <br/>
                            <Button
                                className={classes.button}
                                variant='outlined'
                                onClick={() => this.checkNameChanged(this.state.groupName)}
                            >
                                Save
                            </Button>
                        </DialogContent>
                    </Dialog>
                </div>
            ) : (
                <h1> Loading </h1>
            ))
        )
    }
}
export default withStyles(styles)(Groups);


// WEBPACK FOOTER //
// ./src/pages/Create/groups.jsx